import { Divider, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "@quest_editor/components/SectionHeader";
import TablePagination from "@quest_editor/components/TablePagination";
import FilterSection, { ProgressFilters } from "./FilterSection";
import ProgressTableSection from "./ProgressTableSection";

const ListSection = ({
  filters,
  onFilterChange,
  onSearch,
  promotionTypes,
  ownerTypes,
  pageRows,
  filteredCount,
  page,
  onPageChange,
  pageCount,
  getTypeLabel,
}: {
  filters: ProgressFilters;
  onFilterChange: (key: keyof ProgressFilters, value: string) => void;
  onSearch: () => void;
  promotionTypes: { value: string; label: string }[];
  ownerTypes: { value: string; label: string }[];
  pageRows: {
    promotionId: string;
    promotionName: string;
    promotionType: string;
    promotionOwner: string;
    questId: string;
    questName: string;
    progress: string;
    progressCurrent: number;
    progressTarget: number;
    scheduleStart: string;
    scheduleEnd: string;
  }[];
  filteredCount: number;
  page: number;
  onPageChange: (newPage: number) => void;
  pageCount: number;
  getTypeLabel: (type: string) => string;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Paper
      elevation={0}
      sx={{
        border: 1,
        borderColor: "divider",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      <SectionHeader title={t("quest_progress_list.section.list")} />

      <FilterSection
        filters={filters}
        onFilterChange={onFilterChange}
        onSearch={onSearch}
        promotionTypes={promotionTypes}
        ownerTypes={ownerTypes}
      />

      <Divider />

      <ProgressTableSection
        pageRows={pageRows}
        getTypeLabel={getTypeLabel}
      />

      <Divider />

      <TablePagination
        total={filteredCount}
        page={page - 1}
        setPage={(p) => onPageChange(p + 1)}
        count={pageCount}
      />
    </Paper>
  );
};

export default ListSection;
